var map = {
	"./3d-export.svg": 1455,
	"./a11y.svg": 1456,
	"./ar-badge.svg": 1457,
	"./arrow-down.svg": 1458,
	"./arrow-left.svg": 1459,
	"./arrow-long-left.svg": 1460,
	"./arrow-long-right.svg": 1461,
	"./arrow-right.svg": 1462,
	"./audio.svg": 1463,
	"./bounding.svg": 1464,
	"./close.svg": 1465,
	"./color-companion.svg": 1466,
	"./color-description.svg": 1467,
	"./color-harmony.svg": 1468,
	"./colordrop.svg": 1469,
	"./copy-link.svg": 1470,
	"./cta-right.svg": 1471,
	"./easy-input.svg": 1472,
	"./external.svg": 1473,
	"./hold-frame.svg": 1474,
	"./info.svg": 1475,
	"./modal-close.svg": 1476,
	"./onion-skins.svg": 1477,
	"./palettes.svg": 1478,
	"./pdf-import.svg": 1479,
	"./performance.svg": 1480,
	"./picture-in-picture.svg": 1481,
	"./play-icon.svg": 1482,
	"./pro-tip.svg": 1483,
	"./quickmenu.svg": 1484,
	"./quickshape.svg": 1485,
	"./reduced-motion.svg": 1486,
	"./reset.svg": 1487,
	"./search-thick.svg": 1488,
	"./search.svg": 1489,
	"./select-arrow.svg": 1490,
	"./snapping.svg": 1491,
	"./social-clipboard.svg": 1492,
	"./social-facebook.svg": 1493,
	"./social-twitter.svg": 1494,
	"./sound-active.svg": 1495,
	"./sound-muted.svg": 1496,
	"./streamline.svg": 1497,
	"./success.svg": 1498,
	"./sun.svg": 1499,
	"./text-simple.svg": 1500,
	"./text-sizes.svg": 1501,
	"./text-sizing.svg": 1502,
	"./time-travel.svg": 1503,
	"./valkyrie-engine.svg": 1504,
	"./voice-over.svg": 1505,
	"./warning.svg": 1506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1454;